var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.314,
    height: 3.663,
    viewBox: "0 0 6.314 3.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(-833.595 -445.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M2519.739,1758.391l3.157,3.663,3.157-3.663Z",
    transform: "translate(-1686.144 -1312.79)",
    fill: "#231815"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSelect);
export default __webpack_public_path__ + "static/media/admin-select.c50e97767ef84eba4b6b3a4d3175f1f0.svg";
export { ForwardRef as ReactComponent };